import { NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Home, Globe, Inbox, Menu, type LucideIcon } from 'lucide-react';
import { api } from '../../lib/api';
import { coreNavItems } from '../../lib/panelNavigation';

const DOCK_ICON: Record<string, LucideIcon> = {
  dashboard: Home,
  site: Globe,
  submissions: Inbox,
};

/**
 * Dock inferior mobile (sección 7.4): máximo 4 tabs. Los tres primeros salen
 * del catálogo de navegación (mobileTab); 'Más' abre el drawer existente para
 * la navegación profunda. Oculto en desktop.
 */
export default function MobileDock({ onOpenMore }: { onOpenMore: () => void }) {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    const load = () =>
      api.submissions.unreadCount().then((r) => setUnread(r.count)).catch(() => { /* ignore */ });
    load();
    const onRead = () => setUnread(0);
    window.addEventListener('submissions:read', onRead);
    const interval = setInterval(load, 60_000);
    return () => {
      window.removeEventListener('submissions:read', onRead);
      clearInterval(interval);
    };
  }, []);

  const tabs = coreNavItems.filter((item) => item.mobileTab);

  const tabClass = ({ isActive }: { isActive: boolean }) =>
    `relative flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 text-xs transition-colors ${
      isActive ? 'text-ui-accent' : 'text-ui-text-subtle hover:text-ui-text'
    }`;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 flex items-stretch border-t border-ui-border bg-ui-surface/95 backdrop-blur-sm pb-[env(safe-area-inset-bottom)]"
      aria-label="Navegación principal"
    >
      {tabs.map((item) => {
        const Icon = DOCK_ICON[item.id] ?? Home;
        return (
          <NavLink key={item.id} to={item.to} end={item.id === 'dashboard'} className={tabClass}>
            <span className="relative">
              <Icon size={20} strokeWidth={1.85} />
              {item.id === 'submissions' && unread > 0 && (
                <span className="absolute -top-1 -right-2 text-[10px] font-semibold leading-none bg-ui-accent text-ui-text-inverse rounded-full px-1 py-0.5 min-w-[15px] text-center">
                  {unread > 9 ? '9+' : unread}
                </span>
              )}
            </span>
            {item.label}
          </NavLink>
        );
      })}
      <button type="button" onClick={onOpenMore} className={tabClass({ isActive: false })}>
        <Menu size={20} strokeWidth={1.85} />
        Más
      </button>
    </nav>
  );
}
